import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

export default class AuthenticatedAdminPslfFormSignRoute extends Route {
  @service declare store: StoreService;

  queryParams = {
    signerType: { refreshModel: false },
  };

  async model(params: { form_id: string; signer: string }) {
    return await this.store.findRecord('pslf-form', params.form_id);
  }
}
